import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import selectCustomStyles from 'sites/common/SelectCustomStyles';

export const OperationTypeFilter = ({
  setFiltersAndSort,
  filtersAndSort,
  showAll = true
}) => {
  const options = [
    { value: 1, label: 'Ventas' },
    { value: 2, label: 'Alquileres' },
    { value: 3, label: 'Temporarios' }
  ];

  if (showAll) {
    options.unshift({ value: 0, label: 'Todos' });
  }

  return (
    <div>
      <label>Tipo de Operación</label>
      <Select
        value={options.find(
          option => option.value === filtersAndSort.operation
        )}
        onChange={selectedOption =>
          setFiltersAndSort(state => ({
            ...state,
            operation: selectedOption.value
          }))
        }
        placeholder="Tipo de Operación"
        options={options}
        isSearchable={false}
        styles={selectCustomStyles}
        default
      />
    </div>
  );
};

OperationTypeFilter.propTypes = {
  setFiltersAndSort: PropTypes.func.isRequired,
  filtersAndSort: PropTypes.object.isRequired,
  showAll: PropTypes.bool
};
